import { z } from 'zod';

export const dacScenariosSchema = z.object({
  nom: z.string().min(1, { message: 'Le nom est obligatoire' }),
  description: z.string().min(1, { message: 'La description est obligatoire' }),
  code: z.string().min(1, { message: 'Le code est obligatoire' }),
  modePassationIds: z.array(z.number()).optional(),
});
